export const focusSelect = (inputCurrent) => {
	inputCurrent.focus();
	setTimeout(function () {
		inputCurrent.select();
	});
};


// WEBPACK FOOTER //
// ./src/utils/forms.js